import React from 'react';
import { connect } from 'react-redux';
import ProgressiveJackpot from '../Components/ProgressiveJackpot/index.js';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout/Layout';

const TestJackpot = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: 'Jackpot Test',
        className: 'jackpot',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <h1>Progressive Jackpot Demo</h1>

            <div className='progressive-jackpot-container-sweepstake position-relative my-5 w-50 h-25 d-flex flex-column justify-content-center align-items-center'>
                <h2>Promotion Detail Page</h2>
                <ProgressiveJackpot jackpots={[{ type: 'object', caption: 'Progressive Jackpots' }]} />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TestJackpot);
